module.exports = __webpack_public_path__ + "img/map-library.9abe3e93.png";